import {GetErrorMessagesUnderElement, Clone, CloneWithPrototypes} from "js-vextensions";
import {Column, Pre, RowLR, TextInput, Text} from "react-vcomponents";
import {BaseComponent} from "react-vextensions";
import {User} from "../../Server/DB/users/@User.js";
import {Activity} from "../../Server/DB/activities/@Activity.js";
import React, {useState, useEffect} from "react";

type Props = {baseData: Activity, forNew: boolean, enabled?: boolean, style?, onChange?: (newData: Activity)=>void};
export type ActivityDetailsUI_Ref = {GetValidationError: ()=>string};
export const ActivityDetailsUI = React.forwardRef((props: Props, ref: React.Ref<ActivityDetailsUI_Ref>)=>{
	const {baseData, forNew, enabled, style, onChange} = props;
	const [newData, setNewData] = useState(CloneWithPrototypes(baseData));

	useEffect(()=>{
		setNewData(CloneWithPrototypes(baseData));
	}, [baseData]);

	const Change = ()=>{
		if (onChange) { onChange(GetNewData()); }
	};

	const GetNewData = ()=>{
		return CloneWithPrototypes(newData) as Activity;
	};

	const GetValidationError = ()=>{
		return GetErrorMessagesUnderElement(document.querySelector("[data-activity-details]"))[0];
	};
	React.useImperativeHandle(ref, ()=>({
		GetValidationError
	}));

	const splitAt = 170, width = 600;
	return (
		<Column style={style} data-activity-details>
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>Name: </Text>
				<TextInput required
					enabled={enabled} style={{width: "100%"}}
					value={newData.name} onChange={val=>{newData.name = val; setNewData({...newData}); Change();}}/>
			</RowLR>
			<RowLR mt={5} splitAt={splitAt} style={{width}}>
				<Text>Color: </Text>
				<TextInput required
					enabled={enabled} style={{width: "100%"}}
					value={newData.color} onChange={val=>{newData.color = val; setNewData({...newData}); Change();}}/>
			</RowLR>
		</Column>
	);
});